export interface TelemetryEvent {
  readonly name: string;
  readonly properties?: Readonly<Record<string, boolean | number | string>>;
}

export interface Telemetry {
  capture(event: TelemetryEvent): void;
  captureError(error: unknown, context?: Readonly<Record<string, string>>): void;
}

export const silentTelemetry: Telemetry = {
  capture: () => undefined,
  captureError: () => undefined,
};
